import { Flex, Typography } from '@aloft/toolkit-sui';

import { AlertsContent } from './AlertsContent.tsx';
import { useAlerts } from './hooks/useAlerts.tsx';

export const CraftsmanAlertsSheet = () => {
  const alerts = useAlerts();

  return (
    <Flex flexDirection="column" gap="24px" padding="24px" width="100%">
      <Typography variant="h1">Alerts</Typography>
      <AlertsContent alerts={alerts} />
    </Flex>
  );
};
